/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react'
import { useLocation } from 'react-router'
import { NavLink } from 'react-router-dom'
import SVG from 'react-inlinesvg'
import { toAbsoluteUrl, checkIsActive } from '../../_metronic/_helpers'

export function AsideMenuList({ layoutProps }) {
  const location = useLocation()
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && 'menu-item-active'} menu-item-open `
      : ''
  }

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive('/dashboard', false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl('/media/svg/icons/Design/Layers.svg')} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/Report')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/Report">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Report</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive('/User')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/User">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">User Transaction</span>
          </NavLink>
        </li>

        {/* Components */}
        {/* begin::section */}
        {/*

        <li className="menu-section ">
          <h4 className="menu-text">MANAGE</h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/UserManangement')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/UserManangement">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">User Manangement</span>
          </NavLink>
        </li>

        

        <li
          className={`menu-item ${getMenuItemActive('/MasterCountryVat')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/MasterCountryVat">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Master Country Vat</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/MasterModel')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/MasterModel">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Master Model</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/MasterTCO')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/MasterTCO">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Master TCO</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/MasterFuel')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/MasterFuel">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Master Fuel</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/MasterProd')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/MasterProd">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Master Production</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/MasterMainten')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/MasterMainten">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Master Maintenance</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/MasterResale')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/MasterResale">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Master Resale</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/NewsManagement')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/NewsManagement">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">News Management</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link menu-toggle" to="/">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Product Management</span>
            <i className="menu-arrow" />
          </NavLink>

          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li
                className={`menu-item ${getMenuItemActive('/ProductManagement')}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/ProductManagement">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Product</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive('/GroupItem')}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/GroupItem">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Group Item</span>
                </NavLink>
              </li>

              <li
                className={`menu-item ${getMenuItemActive('/ItemManagement')}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/ItemManagement">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Item</span>
                </NavLink>
              </li>

              <li
                className={`menu-item ${getMenuItemActive('/MachineManagement')}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/MachineManagement">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Machine</span>
                </NavLink>
              </li>

              <li
                className={`menu-item ${getMenuItemActive('/ClassManagement')}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/ClassManagement">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Class</span>
                </NavLink>
              </li>

            </ul>
          </div>
        </li>
        <li
          className={`menu-item ${getMenuItemActive('/ContractUsManagement')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/ContractUsManagement">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Contact Us</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/ItemKeyManagement')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/ItemKeyManagement">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Item Management</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/PreTypeManagement')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/PreTypeManagement">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Presentation Management</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link menu-toggle" to="/">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">SpecCompare Management</span>
            <i className="menu-arrow" />
          </NavLink>

          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li
                className={`menu-item ${getMenuItemActive('/specGroupManagement')}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/specGroupManagement">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Spec Group</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive('/SpecKeyManagement')}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/SpecKeyManagement">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Spec name</span>
                </NavLink>
              </li>

            </ul>
          </div>
        </li>*/}


      </ul>

      {/* end::Menu Nav */}
    </>
  )
}
